// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
enum FiledOptions {
    ALL = 0,
    FILED = 1,
    NOTFILED = 2,
}
export default FiledOptions;
